import { Box, BoxProps, Icon, VisuallyHidden } from '@chakra-ui/react'
import React from 'react'
import { FaSortDown, FaSortUp } from 'react-icons/fa'

interface SortIconsProps extends BoxProps {
  ascending: boolean
  isSortingBy: boolean
}

const SortIcons = ({
  ascending,
  isSortingBy,
  ...restProps
}: SortIconsProps) => (
  <Box
    className="sort-icons"
    display="flex"
    flexDirection="column"
    visibility={isSortingBy ? 'visible' : 'hidden'}
    marginX="-2px"
    {...restProps}
  >
    {isSortingBy && (
      <VisuallyHidden>
        {ascending ? '(Sorted Ascending)' : '(Sorted Descending)'}
      </VisuallyHidden>
    )}
    <Icon
      as={FaSortUp}
      color={ascending ? 'black' : 'gray.500'}
      height="1rem"
      width="1.5rem"
    />
    <Icon
      as={FaSortDown}
      color={ascending ? 'gray.500' : 'black'}
      height="1rem"
      width="1.5rem"
      marginTop="-0.9rem"
    />
  </Box>
)

export default SortIcons
